import React from "react";
import RequestForm from "../components/password-reset/RequestForm";

export default function PasswordResetRequest() {
  return <RequestForm />;
}
